import { render, staticRenderFns } from "./Iprequest.vue?vue&type=template&id=34129fa3&"
import script from "./Iprequest.vue?vue&type=script&lang=ts&"
export * from "./Iprequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports